import { Eye } from 'lucide-react';
import { Alert, AlertDescription } from '@/components/ui/alert';

export const PreviewBanner = () => {
  return (
    <Alert className="border-slate-300 bg-white text-slate-800 shadow-sm dark:border-zinc-700 dark:bg-zinc-900 dark:text-slate-100">
      <Eye className="h-4 w-4 text-slate-700 dark:text-slate-200" />
      <AlertDescription className="text-sm font-medium text-slate-700 dark:text-slate-200">
        Tryb podglądu. Rozpocznij pracę, aby odhaczać zadania.
      </AlertDescription>
    </Alert>
  );
};
